import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import  jwtDecode from 'jwt-decode';
import { pluck } from 'rxjs/operators';
import { login, signUp, updateUser } from '../queries/login.query';
import { BehaviorSubject } from 'rxjs';
import { SlsService } from 'src/app/core/services/sls.service';
import { ToastService } from 'src/app/core/toast.service';
import { forgot, getUser } from '../../sign-up/queries/getUser';

@Injectable()
export class AuthService {

  //isLoggedInSubject = new BehaviorSubject(false);

  constructor(private http: HttpClient,private apollo: Apollo,private sls: SlsService,private toast: ToastService) {
    //this.checkLogin();
   }




  // async register(user): Promise<any> {

  //   let headers = {"x-hasura-admin-secret":`${environment.x_hasura_admin_secret}`};
  //   //headers.append('Content-Type', 'application/json');
  //   //headers.append('x-hasura-admin-secret', `${environment.x_hasura_admin_secret}`);
  //   console.log(user)
  //   const a = {object:user}
  //   try {
  //     const response = await this.http.post(`${environment.serverBasePath}/api/rest/add-lead`, a, { headers : headers }).toPromise();
  //     return response;
  //   } catch (error) {
  //     console.log(error)
  //     throw error;
  //   }
  // }

 async register(favData): Promise<any>{
    console.log(favData)

    try{

      return await this.apollo.use("external").mutate({
        mutation: signUp,
        variables: {signUpObj:favData}
      }).pipe(pluck('data', 'insert_clients_one')).toPromise();

    }catch (error) {
           console.log(error)

           this.toast.openSnackBar(
            'User Already Exits'
          );

           throw error;
         }
   
    
  }

  async updateClient(id: string, updateData: any): Promise<any> {
    console.log(updateData);

    try {
      return await this.apollo.use("external").mutate({
        mutation: updateUser,
        variables: {
          id: id,
          updateObj: updateData
        }
      }).pipe(pluck('data', 'update_clients_by_pk')).toPromise();
    } catch (error) {
      console.log(error);
      this.toast.openSnackBar('Failed to update client');
      throw error;
    }
}

  googleLogin(payload: { token: string }): Promise<any> {
    return this.http.post(
      `${environment.serverPath}/api/v1/auth/googleLogin`,
      payload
    ).toPromise();
  }

  verifyGoogleLogin(token: string ): Promise<any> {
    return this.http.get(
      `${environment.serverPath}/api/v1/event/verify-google-email/${token}`
    ).toPromise();
  }



//   try {

//     //console.log(id)
//     await this.apollo.mutate({
//       mutation: login,
//       variables: details
//     }).toPromise()

//     // await  this.apollo.mutate({
//     //    mutation: login,
//     //    variables: details
//     //  }).toPromise()
//   //this.toast.openSnackBar('Submitted Successfully');
//   return true;
// } catch (err) {
//   console.log(err);
//   //this.toast.openSnackBar('You Failed To Submit');
//   return false;
// }




 login(user: any): Promise<any>{
    const a = {details : user};
    return this.apollo.use("external").mutate({
      mutation: login,
      variables: a
    }).pipe(pluck('data','login_api')).toPromise();
  }




  // checkLogin(): void {
  //   const token: any = this.sls.get('accessToken');
  //   if (!token) {
  //     return;
  //   }
  //   const decodatedToken: any = jwtDecode(token);
  //   const time = Number(Date.now().toString().substring(0, 10));
  //   if (decodatedToken.exp < time) {
  //     this.sls.remove('accessToken');
  //    // this.resetStore();
  //     //.isLoggedInSubject.next(false);
  //     //this.router.navigate(['/home/index']);
  //   } else {
  //    // this.isLoggedInSubject.next(true);
  //   }
  // }

  // resetStore(): void {
  //   subscription.close(true);
  // }


//  async login(user)  {

//   //console.log(user)
//   const details = {details:user}

//   try {

//     //console.log(id)
//     await this.apollo.mutate({
//       mutation: login,
//       variables: details
//     }).toPromise()

//     // await  this.apollo.mutate({
//     //    mutation: login,
//     //    variables: details
//     //  }).toPromise()
//   //this.toast.openSnackBar('Submitted Successfully');
//   return true;
// } catch (err) {
//   console.log(err);
//   //this.toast.openSnackBar('You Failed To Submit');
//   return false;
// }



// }


getUer(id: string): Observable<any> {
  console.log(id)
  return this.apollo.subscribe({
    query: getUser,
    variables: {id}
  }).pipe(pluck('data', 'leads_by_pk'));
}


// getUer(){

// }


// forgotPassword(details){

//   console.log(details)
//   return this.apollo.subscribe({
//     query: forgot,
//     variables: {details}
//   }).pipe(pluck('data', 'forget_password'));

// }

forgotPassword(details: any): Promise<any>{

  const a = details
  return this.apollo.use("external").mutate({
    mutation: forgot,
    variables: a
  }).pipe(pluck('data','forget_password')).toPromise();
}

}
